import * as React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { BuilderComponent } from '@builder.io/react';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import Link from '../components/Link/Link';
import '../builder-settings';
import './app.scss';
import { useEffect } from 'react';

const query = graphql`
  query {
    allBuilderModels {
      header(limit: 1, options: { cachebust: true }) {
        content
      }
      footer(limit: 1, options: { cachebust: true }) {
        content
      }
    }
  }
`;

function PageLayout({ path, children }) {

  const isCheckout = path.search('checkout') !== -1;


  return (
    <StaticQuery query={query}>
      {data => {
        const models = data.allBuilderModels;
        const header = models.header[0].content;
        const footer = models.footer[0].content;
        return (
          <div className={isCheckout ? 'isCheckout' : ''}>
            <div hidden={isCheckout} className="app-header">
              <BuilderComponent
                renderLink={Link}
                name="header"
                content={header}
              />
            </div>
            <div>{children}</div>
            <div hidden={isCheckout} className="app-footer">
              <BuilderComponent
                renderLink={Link}
                name="footer"
                content={footer}
              />
            </div>
          </div>
        );
      }}
    </StaticQuery>
  );
}

export default PageLayout;
